const NomenclatureEnum = {
    building: 1,
    explosion: 2,
    registery: 3
}
export default NomenclatureEnum